import { safeId } from '../../../domain';
import { MainKeys } from '../../main/main.key';
import { Places } from '../../route-consts';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'rs';
/** Os parametros deste place: vao para o endereco. */
const P = {
    /**
     * A empresa que quem administra VARIAS esta administrando agora.
     *
     * Publicado pela CASCA, e nao por uma tela: nao e filtro de lista nenhuma, e
     * contexto - vale para o painel, os colaboradores, o relatorio e os usuarios ao
     * mesmo tempo. Por isso ele sobrevive a troca de tela, e por isso o seletor mora
     * no cabecalho.
     *
     * Distinto do `Empresa` que as telas publicam: aquele e FILTRO do administrador
     * geral, e "todas" e um valor legitimo nele. Aqui "todas" nao existe.
     */
    CompanyInScope: `${PREFIX}a`
};
/** Os atributos deste place: viajam na intencao, mas nao vao para o endereco. */
const A = {
    /** O presenter do HUB, para as telas de dentro pedirem sessao e navegacao. */
    restricted_owner: `${PREFIX}b`
};
/**
 * O que toda tela de dentro do HUB entende.
 *
 * O `owner` e como uma tela pede sessao e navegacao sem buscar nada de novo. E a
 * EMPRESA EM ESCOPO, que a casca publica: ela vale para todas as telas de dentro ao
 * mesmo tempo, e por isso e daqui e nao de cada uma.
 */
export class RestrictedKeys extends MainKeys {
    get place() {
        return Places.hub;
    }
    // :: empresa em escopo
    /**
     * A empresa que quem administra VARIAS esta administrando agora.
     *
     * Publicada pela casca. Nao e filtro - e contexto: vale para o painel, os
     * colaboradores, o relatorio e os usuarios de uma vez, e sobrevive a troca de
     * tela. Ausente para quem administra uma so, que nao tem o que escolher.
     */
    get companyInScope() {
        return safeId(this._intent.getParameterAsNumber(P.CompanyInScope));
    }
    set companyInScope(value) {
        this._intent.setParameter(P.CompanyInScope, value);
    }
    // :: owner
    /**
     * O presenter do HUB.
     *
     * Atributo, entao nunca chega a URL, e escrito pelo `RestrictedPresenter` na
     * descida: o framework caminha da raiz, entao quando uma tela de dentro le
     * isto, o place que a contem ja rodou.
     *
     * Pedir `app.getPresenter` no lugar nao funcionaria, e a razao vale guardar:
     * presenters criados durante um flip so sao comitados quando o flip inteiro
     * da certo - durante ele, a aplicacao ainda responde com os anteriores.
     */
    get owner() {
        return this._intent.attributes.get(A.restricted_owner);
    }
    set owner(value) {
        this._intent.attributes.set(A.restricted_owner, value);
    }
}
//# sourceMappingURL=restricted.key.js.map